import { API_IDS } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { IRewardRepository } from '../../core/repositories/interfaces/iRewardRepository';
import { container } from '../../DataDomain';
import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { IBadgeApiResponse, IQuestApiResponse } from '../../entity/interface/iRewardSystem';
import { IApiPathManager } from '../config/ApiPathManager';

class RewardRepository implements IRewardRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getBadges(identityToken: string, apiKey: string): Promise<IBadgeApiResponse> {
        const path = this.apiPathManager.getPath(API_IDS.REWARD_API_GET_BADGES);
        const response = await this.http.get<IBadgeApiResponse>(path, {
            headers: {
                identityToken,
            },
            params: {
                apikey: apiKey,
            },
        });
        return response.data;
    }

    async getQuests(identityToken: string, apiKey: string): Promise<IQuestApiResponse> {
        const path = this.apiPathManager.getPath(API_IDS.REWARD_API_GET_QUESTS);
        const response = await this.http.get<IQuestApiResponse>(path, {
            headers: {
                identityToken,
            },
            params: {
                apikey: apiKey,
            },
        });
        return response.data;
    }
}

export default RewardRepository;
